import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class StripePaymentService {

  handler: any;
  payClick: boolean

  constructor(private spinner : NgxSpinnerService) { 
    this.loadStripe();
  }

  loadStripe() {
    if(!window.document.getElementById('stripe-script')) {
      var s = window.document.createElement("script");
      s.id = "stripe-script";
      s.type = "text/javascript";
      s.src = "https://checkout.stripe.com/checkout.js";
      s.onload = () => {
        this.handler = (<any>window).StripeCheckout.configure({
          key: environment.STRIPE_PUBLIC_KEY,
          locale: 'auto',
        });
      }
      window.document.body.appendChild(s);
    }
  }

  openCheckout(title: any,amount: any, description:any, image:string, userEmailAddress: any, tokenCallback: (token: any) => void) {
    this.spinner.show();
    const handler = (<any>window).StripeCheckout.configure({
      key: environment.STRIPE_PUBLIC_KEY,
      locale: 'auto',
      token: (token: any) => { 
        this.spinner.show();
        this.payClick = true;
        tokenCallback(token.id); // Pass token.id back to the caller
      },
      closed: () => {
        if(this.payClick){
          this.spinner.show()
        }
        else
        this.spinner.hide() // Hide the spinner when the modal is closed
      }
    });
       
    handler.open({
      name: title,
      description: description,
      amount: amount * 100,
      image: image,
      panelLabel: 'Pay {{amount}}',
      email: userEmailAddress
    });
  }
}
